import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import AdyenCheckout from "@adyen/adyen-web";
// import "@adyen/adyen-web/dist/adyen.css";
import { LoadingService } from "../../services/loading.service";
import { PaymentMethodOption } from "../../model/payment-method-option";
import { cssBrands, adyenCardBrands } from "../../constants/cards";
import { AdyenService } from "../../services/adyen.service";
import { environment } from "../../../../environments/environment";
import { CartService } from "../../services/cart.service";

@Component({
    selector: "pme-adyen-custom-card",
    templateUrl: "./adyen-custom-card.component.html",
    styleUrls: ["./adyen-custom-card.component.scss"],
    standalone: false
})
export class AdyenCustomCardComponent implements OnDestroy {
  @Input() availablePaymentOptions: Array<PaymentMethodOption>;
  @Input() hideConditions: boolean;
  @Input() hasInstallment: boolean = false;
  @Output() selectedOptionInstallment = new EventEmitter();

  state: any;
  encryptedCardNumber: string;
  encryptedExpiryMonth: string;
  encryptedExpiryYear: string;
  encryptedSecurityCode: string;
  encryptedBin: string;
  binValue: string;
  cardHolder: string;
  endDigits: String;
  checkout: any;
  customCard: any;
  createObject: Object;
  paymentMethod: string;
  brand: string;
  currentFocusObject: string;
  errorFields: string[] = [];
  errorsName: Object = {
    encryptedCardNumber: "Número do cartão inválido",
    encryptedExpiryDate: "Data de expiração inválida",
    encryptedSecurityCode: "Código inválido",
    holderNameError: "Nome do cartão inválido",
  };

  cardNumberisFocused: boolean = false;
  cardNameisFocused: boolean = false;
  expiryDateisFocused: boolean = false;
  cvcisFocused: boolean = false;

  cardNameHasValue: boolean = false;
  cardNumberHasValue: boolean = false;
  cvcHasValue: boolean = false;
  expiryDateHasValue: boolean = false;

  isFocused: boolean = false;
  isFocusedExpiry: boolean = false;
  brandIcon: string;
  isValidHolderName: boolean;
  isValid: boolean;
  isValidAdyenData: boolean;
  loaded: boolean = false;
  isValidInstallment: any;
  selectedPaymentCondition: string | null = null;

  styles: Object = {
    base: {
      color: "black",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      fontFamily: "Helvetica",
      background: "white",
      transition: 'background-color 5000s ease-in-out 0s',
    },
    error: {
      color: "red",
    },
    placeholder: {
      color: "#213654",
    },
    validated: {
      color: "green",
    },
  };

  translations: Object = {
    "pt-BR": {
      "creditCard.numberField.placeholder": "Número do cartão",
      "creditCard.expiryDateField.placeholder": "Validade",
      "creditCard.cvcField.placeholder.3digits": "Código de segurança (CVV)",
    },
  };

  configuration = {
    locale: "pt-BR",
    clientKey: "",
    environment: environment.adyen_environment,
    showsHolderNameField: true,
    paymentMethodsConfiguration: {
      ideal: {},
      card: {
        styles: this.styles,
      },
      //Required to apply styling to stored cards.
      storedCard: {
        styles: this.styles,
      },
    },
    translations: this.translations,
  };

  cvvFocus: boolean = false;

  constructor(
    private loading: LoadingService,
    private AdyenService: AdyenService
  ) {
    this.loading.addTask(1);
    this.createObject = {
      // Optional configuration
      type: "card",
      brands: [
        "mc",
        "visa",
        "diners",
        "amex",
        "discover",
        "hipercard",
        "maestro",
        "elo",
        "jcb",
      ],



      // Events
      onChange: (state, component) => {
        this.onChange(state, component);
      },
      onValid: (onValidData) => {
        this.onValid(onValidData);
      },
      onLoad: function () { },
      onConfigSuccess: () => {
        this.onConfigSuccess();
      },
      onFieldValid: (fieldValidData) => {
        this.onFieldValid(fieldValidData);
      },

      onBrand: (brandData) => {
        this.onBrand(brandData);
      },
      onError: (error) => {
        this.onError(error);
      },
      onFocus: (focus) => {
        this.onFocus(focus);
      },
      onBinValue: (bin) => {
        this.onBinValue(bin);
      },
      onBinLookup: (binLookUp) => {
        this.onBinLookup(binLookUp);
      },
    };
    this.paymentMethod = sessionStorage.getItem("paymentMethod");

    this.getClientKey();
  }

  ngOnInit(): void {
    if (this.hideConditions || this.availablePaymentOptions.length > 0) {
      this.selectedPaymentCondition = this.availablePaymentOptions[this.availablePaymentOptions.length -1].identifier;
    }
    if (this.hasInstallment) {
      this.selectedPaymentCondition = this.availablePaymentOptions[this.availablePaymentOptions.length - 1].identifier;
    }
  }

  ngOnChanges(changes) {
    if (changes.availablePaymentOptions) {
      //verifica se as novas opções de parcela contém a previamente selecionada (caso de cupom aplicado)
      const hasPaymentOption = changes.availablePaymentOptions.currentValue
        ? changes.availablePaymentOptions.currentValue.find(
          (opt) => opt.identifier === this.selectedPaymentCondition
        )
        : false;

      if (!hasPaymentOption) {
        this.selectedPaymentCondition = null;
        this.handleIstallments();
      }
    }
  }

  ngAfterViewInit(): void { }

  getClientKey() {
    this.AdyenService.getClientKey().subscribe((result) => {
      this.configuration.clientKey = result?.clientKey;
      this.createAdyenCheckout();
    });
  }

  ngOnDestroy(): void {
    if (this.loaded) return;
    this.loading.finishTask();
  }

  async createAdyenCheckout() {
    AdyenCheckout(Object(this.configuration)).then((result) => {
      this.checkout = result;
      this.mount(this.checkout);
    });
  }

  onChange(state, component) {
    const encryptedExpiryDateElement = document.getElementById(
      "encryptedExpiryDate"
    );
    const encryptedSecurityCodeElement = document.getElementById(
      "encryptedSecurityCode"
    );

    if (
      (state.errors.encryptedCardNumber &&
        state.errors.encryptedCardNumber.errorMessage) ||
      state.valid.encryptedCardNumber === true
    ) {
      this.cardNumberHasValue = true;
    }

    if (
      state.errors &&
      !state.errors.encryptedCardNumber &&
      state.valid.encryptedCardNumber === false
    ) {
      this.cardNumberHasValue = false;
    }

    if (
      (state.errors.encryptedSecurityCode &&
        state.errors.encryptedSecurityCode.errorMessage) ||
      state.valid.encryptedSecurityCode === true
    ) {
      this.cvcHasValue = true;
    }

    if (
      state.errors &&
      !state.errors.encryptedSecurityCode &&
      state.valid.encryptedSecurityCode === false
    ) {
      this.cvcHasValue = false;
    }

    if (
      (state.errors.encryptedExpiryDate &&
        state.errors.encryptedExpiryDate.errorMessage) ||
      (state.valid.encryptedExpiryMonth === true &&
        state.valid.encryptedExpiryYear === true)
    ) {
      this.expiryDateHasValue = true;
    }
    if (
      state.errors &&
      !state.errors.encryptedExpiryDate &&
      (state.valid.encryptedExpiryMonth === false ||
        state.valid.encryptedExpiryYear === false)
    ) {
      this.expiryDateHasValue = false;
    }

    this.handleErrors(state.errors);
    if (state.isValid) {
      this.state = state;
      this.isValidAdyenData = true;
      this.isValid =
        this.isValidHolderName && this.selectedPaymentCondition ? true : false;
      this.encryptedCardNumber = state.data.paymentMethod.encryptedCardNumber;
      this.encryptedExpiryMonth = state.data.paymentMethod.encryptedExpiryMonth;
      this.encryptedExpiryYear = state.data.paymentMethod.encryptedExpiryYear;
      this.encryptedSecurityCode =
        state.data.paymentMethod.encryptedSecurityCode;
    } else {
      this.isValidAdyenData = false;
      this.isValid = false;
      this.encryptedCardNumber = "";
      this.encryptedExpiryMonth = "";
      this.encryptedExpiryYear = "";
      this.encryptedSecurityCode = "";
    }
  }
  onValid(onValidData) { }

  onConfigSuccess() {
    //Close Spinner
    this.loading.finishTask();
    this.loaded = true;
  }

  onFieldValid(fieldValidData) {
    if (fieldValidData && fieldValidData.endDigits) {
      this.endDigits = fieldValidData.endDigits;
    }
  }

  onBrand(brandData) {
    if (brandData && brandData.brand) {
      this.brand = adyenCardBrands[brandData.brand];
      this.brandIcon = this.getBrandIcon();
    }
  }

  onError(errors) { }

  onFocus(e) {
    if (this.currentFocusObject)
      document
        .getElementById(this.currentFocusObject)
        .classList.remove("focus");

    if (this.currentFocusObject === "encryptedSecurityCode") {
      this.cvvFocus = false;
      this.cvcisFocused = false;
    }
    if (this.currentFocusObject === "encryptedExpiryDate") {
      this.expiryDateisFocused = false;
    }
    if (this.currentFocusObject === "encryptedCardNumber") {
      this.cardNumberisFocused = false;
    }

    this.currentFocusObject = e.currentFocusObject;

    if (this.currentFocusObject)
      document.getElementById(this.currentFocusObject).classList.add("focus");

    if (this.currentFocusObject === "encryptedSecurityCode") {
      this.cvvFocus = true;
      this.cvcisFocused = true;
    }
    if (this.currentFocusObject === "encryptedExpiryDate") {
      this.expiryDateisFocused = true;
    }
    if (this.currentFocusObject === "encryptedCardNumber") {
      this.cardNumberisFocused = true;
    }
  }

  onBinValue(bin) {
    if (bin && bin.binValue && bin.encryptedBin) {
      this.encryptedBin = bin.encryptedBin;
      this.binValue = bin.binValue;
    }
  }

  onBinLookup(binLookUp) { }

  mount(checkout) {
    if (checkout) {
      this.customCard = this.checkout
        .create("securedfields", this.createObject)
        .mount("#customCard-container");
    }
  }

  unmount() {
    if (this.checkout && this.customCard) {
      this.customCard.unmount();
    }
  }

  handleErrors(errors) {
    Object.keys(errors).forEach((fieldName) => {
      let field = document.getElementById(fieldName);
      let fieldTitle = document.getElementById(fieldName + "Title");
      let errorField = document.getElementById(fieldName + "Error");

      if (!errors[fieldName] && field) {
        field.classList.remove("error");
        errorField.classList.remove("show");
        errorField.innerText = "";

        fieldTitle.classList.remove("error");

        if (this.errorFields.includes(fieldName)) {
          this.errorFields = this.errorFields.filter((v) => v != fieldName);
        }

        return;
      }

      this.isValid = false;
      if (field && field.classList) {
        field.classList.add("error");
        errorField.classList.add("show");
      }
      errorField.innerText = this.errorsName[fieldName];

      if (fieldTitle && fieldTitle.classList) {
        fieldTitle.classList.add("error");
      }
      this.errorFields.push(fieldName);
    });
  }

  cardHolderNameErrors() {
    let name = this.cardHolder;

    let regex = /[a-zA-Z]|\s/gm;
    let fieldName = "holderName";
    let field = document.getElementById(fieldName);
    let fieldTitle = document.getElementById(fieldName + "Title");
    let errorField = document.getElementById(fieldName + "Error");
    let inputName = document.getElementById(fieldName + "Input");

    if (name && name.replace(regex, "") !== "") {
      if (field && field.classList) {
        field.classList.add("error");
      }
      if (errorField && errorField.classList) {
        errorField.classList.add("show");
        errorField.innerText = this.errorsName[fieldName + "Error"];
        this.errorFields.push(fieldName);
      }
      if (fieldTitle && fieldTitle.classList) {
        fieldTitle.classList.add("error");
      }
      if (inputName && inputName.classList) {
        inputName.classList.add("errorLabelName");
        inputName.classList.remove("rightLabelName");
      }
      this.isValidHolderName = false;
    } else if (name) {
      if (field && field.classList) {
        field.classList.remove("error");
      }
      if (errorField && errorField.classList) {
        errorField.classList.remove("show");
        errorField.innerText = "";
      }
      if (fieldTitle && fieldTitle.classList) {
        fieldTitle.classList.remove("error");
      }

      if (inputName && inputName.classList) {
        inputName.classList.remove("error");
        inputName.classList.add("rightLabelName");
      }

      if (this.errorFields.includes(fieldName)) {
        this.errorFields = this.errorFields.filter((v) => v != fieldName);
        fieldTitle.classList.remove("error");
      }

      this.isValidHolderName = true;
    } else {
      // Quando o campo está vazio
      if (field && field.classList) {
        fieldTitle.classList.remove("error");
        field.classList.remove("error");
      }
      if (errorField && errorField.classList) {
        errorField.classList.remove("show");
        errorField.innerText = "";
      }
      this.isValidHolderName = false;
    }
  }

  theresInputValue(text: string, propertyName: string) {
    let hasValue = text && text.trim() !== "";

    switch (propertyName) {
      case "cvc":
        this.cvcHasValue = hasValue ? true : false;
        break;
      case "cardName":
        this.cardNameHasValue = hasValue ? true : false;

        break;
      case "expiryDate":
        this.expiryDateHasValue = hasValue ? true : false;
        break;
      case "cardNumber":
        this.cardNumberHasValue = hasValue ? true : false;
        break;
      default:
        break;
    }
  }

  ngDoCheck() {
    this.handleIstallments();
    this.cardHolderNameErrors();
    if (
      this.isValidHolderName &&
      this.selectedPaymentCondition &&
      this.isValidAdyenData
    ) {

      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }

  getBrandIcon(): string {
    return cssBrands[this.brand];
  }

  handleIstallments() {
    this.selectedOptionInstallment.emit(this.availablePaymentOptions.find(opt => {
      return opt.identifier === this.selectedPaymentCondition;
    }));
  }
}
